import { memo } from 'react';
import PropTypes from 'prop-types';

import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

import { getIconInfo } from './utils';

export const ImproveModeIcon = memo(({ className, mode }) => {
  const info = getIconInfo(mode);
  if (!info?.Icon) {
    return null;
  }

  const { Icon, ...props } = info;
  return (
    <Icon
      className={className}
      {...props}
    />
  );
});

ImproveModeIcon.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.oneOf(Object.values(GENERATION_IMPROVE_MODE)).isRequired,
};

ImproveModeIcon.defaultProps = {
  className: null,
};
